import { useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SESSION_STORAGE } from "../helpers/constants";
import {
  DIALOG_NAME,
  useDialogSearchParam,
} from "../helpers/useDialogSearchParam";
import { useBreakpoints } from "../lib/breakpoints";
import LoginModal from "./login/LoginModal";

const ContentGate = () => {
  const [isParamSet, removeParam] = useDialogSearchParam(DIALOG_NAME.login);
  const { isMobile } = useBreakpoints();
  const location = useLocation();
  const navigate = useNavigate();

  /** Mobile uses `/login` full page; strip `?login` so we never mount the legacy bottom sheet. */
  useLayoutEffect(() => {
    if (!isMobile || !isParamSet) return;
    const path = location.pathname;
    if (
      path &&
      path !== "/login" &&
      path !== "/signup" &&
      path !== "/forgot-password"
    ) {
      sessionStorage.setItem(SESSION_STORAGE.redirectUrl, path);
    }
    removeParam();
    navigate("/login", { replace: true });
    // removeParam from useDialogSearchParam is not referentially stable
  }, [isMobile, isParamSet, navigate, location.pathname, removeParam]);

  const onClose = () => {
    removeParam();
  };

  return (
    <>
      <LoginModal isOpen={isParamSet && !isMobile} onClose={onClose} />
    </>
  );
};

export default ContentGate;
